import styled, { keyframes } from 'styled-components'
import {
  INSTANT_ESTIMATE_BG,
} from '@CSSVars/colors'


const estimateLightning = keyframes`
  0% {
      transform: scale(.6);
  }

  50% {
    transform: scale(1.2);
  }
  100% {
      transform: scale(.6);
  }
`

const estimateCircle = keyframes`
  0% {
    transform: translate3d(-50%, -50%, 0) scale(0);
  }

  50% {
    transform: translate3d(-50%, -50%, 0) scale(0);
  }

  100% {
    transform: translate3d(-50%, -50%, 0) scale(1.1);
  }
`


export const _EstimateAnimation = styled.div.attrs({
  className: 'estimateAnimation',
})`
  display: inline-flex;
  position: relative;
/*  justify-content: center;*/
/*  align-items: center;*/

`


export const _Lightning = styled.div`
  width: 16px;

  svg {
    width: 100%;
    fill: ${INSTANT_ESTIMATE_BG};
  }

  animation: ${estimateLightning} 1300ms infinite ease-in-out;
  animation-timing-function: cubic-bezier(.7,0,.3,1);
`


export const _Circle = styled.div`
  width: 16px;
  height: 16px;
  content: "";
  border: 2px solid ${INSTANT_ESTIMATE_BG};
  border-radius: 50%;
  position: absolute;

  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0) scale(1);

  animation: ${estimateCircle} 1300ms infinite ease-in;
/*  animation-delay: 500ms;*/
`

